// Marketplace front-end category filter (client-side, fast).
//   <ul class="cs-category-bar" data-cs-filter>
//     <li><a class="cs-category-bar__item is-active" data-filter="all">All</a></li>
//     <li><a class="cs-category-bar__item" data-filter="security">Security</a></li>
//   </ul>
//   <div class="cs-product-grid" data-cs-filter-target>
//     <article data-cats="security marketing">…</article>
//   </div>

export function initCategoryFilter() {
	const bar = document.querySelector('[data-cs-filter]');
	const grid = document.querySelector('[data-cs-filter-target]');
	if (!bar || !grid) return;

	const items = bar.querySelectorAll('[data-filter]');
	const cards = grid.querySelectorAll('[data-cats]');

	bar.addEventListener('click', (e) => {
		const trigger = e.target.closest('[data-filter]');
		if (!trigger) return;
		e.preventDefault();

		items.forEach((i) => i.classList.toggle('is-active', i === trigger));

		const filter = trigger.getAttribute('data-filter');
		cards.forEach((card) => {
			const cats = (card.getAttribute('data-cats') || '').split(/\s+/);
			const visible = filter === 'all' || cats.includes(filter);
			card.style.display = visible ? '' : 'none';
		});
	});
}
